import { GET_USER, GET_USER_DATA, NEW_USER_INIT } from '../constants';
import User from '../models/User';
import { updateObject, createReducer } from './common';

export const initialState = { 
    user: new User(),
};

const handler = {
    [GET_USER]: (state) => updateObject(state, { user: new User() }),
    [GET_USER_DATA]: (state, action) => updateObject(state, { user: action.payload }),
    [NEW_USER_INIT]: () => ({ ...initialState }),
}

export const userReducer = createReducer(initialState, handler);